import React__default, { useMemo, useState } from 'react';
import { S as SearchContext } from './SearchContext-BWoADqXi.js';
import { s as sanitizeCountries } from '../../utils/sanitizeCountries-_TWllG0n.js';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { u as useSearchCountries } from '../../hooks/useSearchCountries-Ejwakgcv.js';

const SearchProvider = ({
  children,
  countries = [],
  exclude = [],
  searchValue = ''
}) => {
  const {
    formatMessage
  } = useIntl();
  const countryLabels = useMemo(() => sanitizeCountries(countries).filter(country => !exclude.includes(country)).reduce((acc, countryCode) => ({
    ...acc,
    [formatMessage({
      id: `option-label-${countryCode}`
    })]: countryCode
  }), {}), [countries, exclude, formatMessage]);
  const [searchTerm, setSearchTerm] = useState(searchValue);
  const searchResults = useSearchCountries({
    countries,
    exclude,
    labels: {
      ...countryLabels
    },
    match: searchTerm
  });
  return /*#__PURE__*/React__default.createElement(SearchContext.Provider, {
    value: {
      countries,
      exclude,
      results: searchResults,
      searchValue: searchTerm,
      setSearchValue: setSearchTerm
    }
  }, children);
};

export { SearchProvider as S };
//# sourceMappingURL=SearchProvider-g9yXpIGv.js.map
